import { Route, Routes } from "react-router-dom";
import PrivateAuth from "../../authorization/PrivateAuth";

function WarehouseRoute() {

    return (
        <Routes>
            <Route element={<PrivateAuth />}>
             
            </Route>
        </Routes>
    )
}
export default WarehouseRoute;